enum Language {
	LT = 'lt',
	EN = 'en'
}

export default Language;
